// SPDX-License-Identifier: AGPL-3.0-or-later
import {MAX_LINES} from '@app/vendor/markdown_parser/types/MarkdownConstants';
export interface ParserInput {
	lines: Array<string>;
	totalLineCount: number;
}
export function createParserInput(input: string): ParserInput {
	if (!input || input === '') {
		return {lines: [], totalLineCount: 0};
	}
	const lines = input['split']('\n');
	if (lines.length > MAX_LINES) {
		lines.length = MAX_LINES;
	}
	if (lines.length === 1 && lines[0] === '') {
		return {lines: [], totalLineCount: 0};
	}
	return {
		lines,
		totalLineCount: lines.length,
	};
}
